import Textfield from "../../../common/components/Textfiled.jsx"
import Select from "../../../common/components/Select.jsx"
import Button from "../../../common/components/Button.jsx"
import {useMemo} from "react";


const OPTIONS_DEPARTMENTS = [
  { value: "Amazonas", label: "Amazonas" },
  { value: "Antioquia", label: "Antioquia" },
  { value: "Arauca", label: "Arauca" },
  { value: "Atlántico", label: "Atlántico" },
  { value: "Bolívar", label: "Bolívar" },
  { value: "Boyacá", label: "Boyacá" },
  { value: "Caldas", label: "Caldas" },
  { value: "Caquetá", label: "Caquetá" },
  { value: "Casanare", label: "Casanare" },
  { value: "Cauca", label: "Cauca" },
  { value: "Cesar", label: "Cesar" },
  { value: "Chocó", label: "Chocó" },
  { value: "Córdoba", label: "Córdoba" },
  { value: "Cundinamarca", label: "Cundinamarca" },
  { value: "Guainía", label: "Guainía" },
  { value: "Guaviare", label: "Guaviare" },
  { value: "Huila", label: "Huila" },
  { value: "La Guajira", label: "La Guajira" },
  { value: "Magdalena", label: "Magdalena" },
  { value: "Meta", label: "Meta" },
  { value: "Nariño", label: "Nariño" },
  { value: "Norte de Santander", label: "Norte de Santander" },
  { value: "Putumayo", label: "Putumayo" },
  { value: "Quindío", label: "Quindío" },
  { value: "Risaralda", label: "Risaralda" },
  { value: "San Andrés y Providencia", label: "San Andrés y Providencia" },
  { value: "Santander", label: "Santander" },
  { value: "Sucre", label: "Sucre" },
  { value: "Tolima", label: "Tolima" },
  { value: "Valle del Cauca", label: "Valle del Cauca" },
  { value: "Vaupés", label: "Vaupés" },
  { value: "Vichada", label: "Vichada" },
];

const OPTIONS_CITIES = [
  { value: "Leticia", label: "Leticia", department: "Amazonas" },
  { value: "Medellín", label: "Medellín", department: "Antioquia" },
  { value: "Bello", label: "Bello", department: "Antioquia" },
  { value: "Arauca", label: "Arauca", department: "Arauca" },
  { value: "Barranquilla", label: "Barranquilla", department: "Atlántico" },
  { value: "Cartagena", label: "Cartagena", department: "Bolívar" },
  { value: "Tunja", label: "Tunja", department: "Boyacá" },
  { value: "Manizales", label: "Manizales", department: "Caldas" },
  { value: "Florencia", label: "Florencia", department: "Caquetá" },
  { value: "Yopal", label: "Yopal", department: "Casanare" },
  { value: "Popayán", label: "Popayán", department: "Cauca" },
  { value: "Valledupar", label: "Valledupar", department: "Cesar" },
  { value: "Quibdó", label: "Quibdó", department: "Chocó" },
  { value: "Montería", label: "Montería", department: "Córdoba" },
  { value: "Bogotá", label: "Bogotá", department: "Cundinamarca" },
  { value: "Villavicencio", label: "Villavicencio", department: "Meta" },
  { value: "Neiva", label: "Neiva", department: "Huila" },
  { value: "Riohacha", label: "Riohacha", department: "La Guajira" },
  { value: "Santa Marta", label: "Santa Marta", department: "Magdalena" },
  { value: "San José del Guaviare", label: "San José del Guaviare", department: "Guaviare" },
  { value: "Puerto Carreño", label: "Puerto Carreño", department: "Vichada" },
  { value: "Pasto", label: "Pasto", department: "Nariño" },
  { value: "Cúcuta", label: "Cúcuta", department: "Norte de Santander" },
  { value: "Mocoa", label: "Mocoa", department: "Putumayo" },
  { value: "Armenia", label: "Armenia", department: "Quindío" },
  { value: "Pereira", label: "Pereira", department: "Risaralda" },
  { value: "San Andrés", label: "San Andrés", department: "San Andrés y Providencia" },
  { value: "Bucaramanga", label: "Bucaramanga", department: "Santander" },
  { value: "Sincelejo", label: "Sincelejo", department: "Sucre" },
  { value: "Ibagué", label: "Ibagué", department: "Tolima" },
  { value: "Cali", label: "Cali", department: "Valle del Cauca" },
  { value: "Tuluá", label: "Tuluá", department: "Valle del Cauca" },
  { value: "Buga", label: "Buga", department: "Valle del Cauca" },
  { value: "Palmira", label: "Palmira", department: "Valle del Cauca" },
  { value: "Mitú", label: "Mitú", department: "Vaupés" },
  { value: "Inírida", label: "Inírida", department: "Guainía" },
];

const OPTIONS_STATUS = [
  { value: "registrada", label: "Registrada" },
  { value: "notificada", label: "Notificada" },
  { value: "en_proceso", label: "En proceso" },
  {value : "pagada", label: "Pagada"},
  {value : "anulada", label: "Anulada"},
  {value: "vencida", label: "Vencida"},
]

function FormInfraction({infraction, onChange, onSubmit, errors}){

  const handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    if(onSubmit){
      onSubmit();
    }
  }

  const handleOptionsCity = () => {
    const selectedDepartment = infraction.department;
    return OPTIONS_CITIES.filter(city => city.department === selectedDepartment);
  } 

  const optionsCity = useMemo(handleOptionsCity, [infraction.department]);

  return (    
<form onSubmit={handleSubmit} className="container mt-4">
  <div className="row">
    <div className="col-md-6 mb-3">
      <Textfield 
        label="Código" 
        placeholder="Código" 
        name="code" 
        value={infraction.code} 
        onChange={onChange} 
        error={errors.code} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Textfield 
        label="Fecha" 
        type="date" 
        name="date" 
        value={infraction.date} 
        onChange={onChange} 
        error={errors.date} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Textfield 
        label="Nombre del conductor" 
        placeholder="Nombre del conductor" 
        name="driverName" 
        value={infraction.driverName} 
        onChange={onChange} 
        error={errors.driverName} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Textfield 
        label="Identificación del conductor" 
        placeholder="Identificación del conductor" 
        name="driverIdentification" 
        value={infraction.driverIdentification} 
        onChange={onChange} 
        error={errors.driverIdentification} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Textfield 
        label="Placa" 
        placeholder="Placa" 
        name="plate" 
        value={infraction.plate} 
        onChange={onChange} 
        error={errors.plate} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Textfield 
        label="Tipo de infracción" 
        name="type" 
        value={infraction.type} 
        onChange={onChange}  
        error={errors.type} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Select 
        label="Departamento" 
        name="department" 
        value={infraction.department} 
        onChange={onChange} 
        options={OPTIONS_DEPARTMENTS} 
        error={errors.department} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Select 
        label="Ciudad" 
        name="city" 
        value={infraction.city} 
        onChange={onChange} 
        options={optionsCity} 
        error={errors.city} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Textfield 
        label="Autoridad" 
        placeholder="Autoridad" 
        name="authority" 
        value={infraction.authority} 
        onChange={onChange} 
        error={errors.authority} 
      />
    </div>
    <div className="col-md-6 mb-3">
      <Select 
        label="Estado" 
        name="status" 
        value={infraction.status} 
        onChange={onChange} 
        options={OPTIONS_STATUS} 
        error={errors.status} 
      />
    </div>
  </div>

  <div className="mt-4">
    <Button type="submit">
      Guardar Infracción
    </Button>
  </div>
</form>
  )
}

export default FormInfraction;
